import React, { useContext } from 'react'
import { LanguageContext } from '../../../container/Language';
import profile from '../../../images/profile.png'


const Profile = () => {
  const { dictionary: { jobTitle } } = useContext(LanguageContext);

  return (
    <>
      <div className="profile">
        <div className="image">
          <a href="#">
            <img src={profile} alt="Ryan Adlard" />
          </a>
        </div>
        <div className="title">Johan Mickaël</div>
        <div className='subtitle'>{jobTitle.title}</div>
        <div className="subtitle subtitle-typed">
          <div className="typing-title">
            {
              jobTitle.item.map((item, i) => (<p key={`jobtitle-${i}`}>{item}</p>))
            }
          </div>
        </div>
      </div>

      <a href="#" className="menu-btn"><span></span></a>
    </>
  )
}

export default Profile